import script from "./DeleteRecordingConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteRecordingConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./DeleteRecordingConfirmation.vue?vue&type=style&index=0&id=2f0a058c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0a058c"]])

export default __exports__